export interface ConsoleReleaseInfo {
  version: string;
  commit: string;
  buildTime: string;
  dirty?: boolean;
  sourceHash?: string;
}

declare const __HOTX_CONSOLE_RELEASE__: ConsoleReleaseInfo | undefined;

// 控制台版本维护约定，更新时间：2026-09-09 CST。0.1.92 收口全量回归、自动续期确认和 DNS 可执行错误提示。
// 版本号保持简短易懂，每次运营代码更新后递增末位；左下角构建时间由 Vite 在打包时自动写入并按北京时间展示。
const fallbackReleaseInfo: ConsoleReleaseInfo = {
  version: '0.1.92',
  commit: 'local',
  buildTime: 'local'
};

export const consoleReleaseInfo: ConsoleReleaseInfo =
  typeof __HOTX_CONSOLE_RELEASE__ === 'undefined' ? fallbackReleaseInfo : __HOTX_CONSOLE_RELEASE__;

export function shortCommit(commit: string): string {
  const normalized = commit.trim();
  return normalized.length > 7 ? normalized.slice(0, 7) : normalized || 'local';
}

export function formatConsoleBuildTime(buildTime: string, withYear = false): string {
  const date = new Date(buildTime);
  if (Number.isNaN(date.getTime())) {
    return '本地构建';
  }

  // 左下角版本号只展示用户能直接看懂的北京时间，不展示 commit/local 等工程标记；
  // git commit 和 sourceHash 仍写入 dist/release.json，排查问题时再看完整发布信息。
  const chinaTime = new Date(date.getTime() + 8 * 60 * 60 * 1000);
  const year = chinaTime.getUTCFullYear();
  const month = padDatePart(chinaTime.getUTCMonth() + 1);
  const day = padDatePart(chinaTime.getUTCDate());
  const hour = padDatePart(chinaTime.getUTCHours());
  const minute = padDatePart(chinaTime.getUTCMinutes());
  const datePart = withYear ? `${year}-${month}-${day}` : `${month}-${day}`;
  return `${datePart} ${hour}:${minute}`;
}

export function buildConsoleReleaseLabel(info: ConsoleReleaseInfo = consoleReleaseInfo): string {
  return `控制台版 ${info.version} · ${formatConsoleBuildTime(info.buildTime)}`;
}

function padDatePart(value: number): string {
  return String(value).padStart(2, '0');
}
